import http from './http.js';

/**
 * Fetch 3D coverflow hero books (popular & bestselling from Sri Lanka & worldwide) from backend.
 */
export async function fetchHeroBooks() {
  try {
    const res = await http.get('/hero');
    return res?.items || res || [];
  } catch {
    return [];
  }
}

/**
 * Fetch home page catalog payload (newReleases and secondhandFinds) directly from backend.
 */
export async function fetchHome() {
  try {
    const res = await http.get('/home');
    return res || { newReleases: [], secondhandFinds: [], heroBooks: [] };
  } catch {
    return { newReleases: [], secondhandFinds: [], heroBooks: [] };
  }
}

/**
 * Fetch paginated catalog list for publisher or secondhand books directly from backend.
 */
export async function fetchCatalogList(kind, params = {}) {
  const cleanParams = Object.fromEntries(
    Object.entries(params).filter(([, v]) => v !== undefined && v !== null && v !== ''),
  );

  try {
    const res = await http.get(`/books/${kind}`, { params: cleanParams, withMeta: true });
    return res || { data: { items: [] }, meta: { total: 0, totalPages: 0, page: 1, limit: 12 } };
  } catch {
    return { data: { items: [] }, meta: { total: 0, totalPages: 0, page: 1, limit: 12 } };
  }
}

/**
 * Fetch available catalog filters (categories, publishers, min/max price) from backend.
 */
export async function fetchCatalogFilters(kind) {
  try {
    const res = await http.get(`/books/${kind}/filters`);
    return res || { categories: [], publishers: [], minPrice: 0, maxPrice: 0 };
  } catch {
    return { categories: [], publishers: [], minPrice: 0, maxPrice: 0 };
  }
}

/**
 * Fetch individual book detail by slug or ID from backend.
 */
export async function fetchBookDetail(kind, slug) {
  try {
    const res = await http.get(`/books/${kind}/${slug}`);
    return res || null;
  } catch {
    return null;
  }
}

/**
 * Fetch categories taxonomy from backend.
 */
export async function fetchCategories() {
  const res = await http.get('/categories');
  return res || { items: [] };
}

/**
 * Fetch publishers list from backend.
 */
export async function fetchPublishers() {
  try {
    const res = await http.get('/publishers');
    return res || { items: [] };
  } catch {
    return { items: [] };
  }
}

export default {
  fetchHeroBooks,
  fetchHome,
  fetchCatalogList,
  fetchCatalogFilters,
  fetchBookDetail,
  fetchCategories,
  fetchPublishers,
};
